// Stub module — re-exports the new Card from the primitives barrel.
// Older imports `import { Card, CardContent } from "@/components/ui/card"`
// keep compiling while pages are migrated.

export { Card as default, Card } from './ApplePrimitives';

export function CardHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={`card-header ${className ?? ''}`}>{children}</div>;
}

export function CardTitle({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={`text-[16px] font-semibold ${className ?? ''}`}>{children}</div>;
}

export function CardContent({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={className}>{children}</div>;
}